import React from 'react';
import classes from './Progress.scss';
import PropTypes from 'prop-types';

const Spinner = ({ percent, children }) => (
  <div className={classes['progress']}>
    <div className={`${classes['bar']} ${percent === 100 ? classes['done'] : ''}`} style={{width: percent + '%'}}>
      {children}
    </div>
  </div>
);

Spinner.propTypes = {
  percent: PropTypes.number.isRequired,
  children: PropTypes.node
};

export default Spinner;
